var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    [
      _c("vs-col", { attrs: { "vs-w": "2" } }, [
        _c("strong", [_vm._v("Periodo de trabajo:")])
      ]),
      _c(
        "vs-col",
        { attrs: { "vs-w": "2" } },
        [
          _c("vs-input", {
            staticClass: "pickadate pickadate-firstday",
            attrs: { type: "date" },
            model: {
              value: _vm.desde,
              callback: function($$v) {
                _vm.desde = $$v
              },
              expression: "desde"
            }
          })
        ],
        1
      ),
      _c("vs-col", { attrs: { "vs-w": "1" } }, [_vm._v(" a ")]),
      _c(
        "vs-col",
        { attrs: { "vs-w": "2" } },
        [
          _c("vs-input", {
            staticClass: "pickadate pickadate-firstday",
            attrs: { type: "date" },
            model: {
              value: _vm.hasta,
              callback: function($$v) {
                _vm.hasta = $$v
              },
              expression: "hasta"
            }
          })
        ],
        1
      ),
      _c("br"),
      _c("br")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }